import React, { useState } from "react";
import { BellRing } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const OPTIONS = [
  ["email", "Email + in-app", "An email and a bell notification each time"],
  ["in_app", "In-app only", "Just a bell notification, no email"],
  ["off", "Off", "No owner change alerts at all"],
];

export const AlertPrefsButton = ({ testId = "alert-prefs-button" }) => {
  const [open, setOpen] = useState(false);
  const [pref, setPref] = useState(null);
  const openDialog = async () => {
    setOpen(true);
    try { const { data } = await api.get("/auth/me"); setPref(data.alert_prefs?.owner_change_alerts || "email"); }
    catch (e) { toast.error(apiError(e)); }
  };
  const choose = async (v) => {
    try { await api.put("/auth/me/alert-prefs", { owner_change_alerts: v }); setPref(v); toast.success("Alert preference saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <>
      <Button data-testid={testId} variant="ghost" className="w-full justify-start text-muted-foreground" onClick={openDialog}>
        <BellRing className="h-4 w-4 mr-2" /> Alert preferences
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="alert-prefs-dialog">
          <DialogHeader>
            <DialogTitle className="font-head">Owner change alerts</DialogTitle>
            <DialogDescription>When an owner's onboarding form changes property or owner details.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {OPTIONS.map(([v, label, hint]) => (
              <button key={v} type="button" data-testid={`alert-pref-${v}`} onClick={() => choose(v)} disabled={!pref}
                className={`w-full text-left border rounded-md px-4 py-3 transition-colors ${pref === v ? "border-[#2B4C3F] bg-[#2B4C3F]/8" : "border-border hover:bg-secondary/60"}`}>
                <span className="text-sm font-medium flex items-center gap-2">
                  <span className={`h-3 w-3 rounded-full border ${pref === v ? "bg-[#2B4C3F] border-[#2B4C3F]" : "border-muted-foreground"}`} />{label}
                </span>
                <span className="block text-xs text-muted-foreground ml-5 mt-0.5">{hint}</span>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
